import { PATHS } from 'routes/constants';
import React from 'react';
import {
	CreditCard,
	HistoryEdu as HistoryEduIcon,
	IntegrationInstructions,
	PeopleAlt,
	PriceChange,
	Public,
	Security,
	Settings,
	Storefront,
	UploadFile,
} from '@mui/icons-material';

export const SHOPIFY_PRICING_URL = 'https://easproject.com/s-pricing';
// console.log('window.location.origin', window.location.origin);
const PRICING_PAGE = window.location.origin.includes('2024.easproject.com')
	? SHOPIFY_PRICING_URL
	: PATHS.PRICING_PAGE;

export enum NAVIGATE_ITEMS {
	DASHBOARD = 'Dashboard',
	ORDERS = 'Orders',
	REFUNDS = 'Refunds',
	INVOICES = 'Invoices',
	SALES_REPORTS = 'Sales Reports',
	VAT_REPORTS = 'VAT Reports',
	VAT_CORRECTIONS = 'VAT Corrections',
	SHIPMENTS = 'Shipments',
	GPSR_SERVICE = 'GPSR Service',
	EUDR_SERVICE = 'EUDR Service',
	EU_DDP_SHIPMENTS = 'EU DDP Shipments',
	EPR_PPWR = 'EPR/PPWR',
}

export const NAVIGATE = [
	{
		name: NAVIGATE_ITEMS.DASHBOARD,
		path: PATHS.DASHBOARD_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.ORDERS,
		path: PATHS.ORDERS_PAGE, // /${ORDERS_PATHS.CONFIRMED_ORDERS_PAGE}`,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.REFUNDS,
		path: PATHS.REFUNDS_PAGE,
		badge: 'New',
	},
	{
		name: NAVIGATE_ITEMS.INVOICES,
		path: PATHS.INVOICES_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.SALES_REPORTS,
		path: PATHS.SALES_REPORTS_PAGE,
		// .replace(':typeOfReport', B2B_REPORT_PATHS),
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.VAT_REPORTS,
		path: PATHS.VAT_REPORTS_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.VAT_CORRECTIONS,
		path: PATHS.VAT_CORRECTIONS_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.SHIPMENTS,
		path: PATHS.SHIPMENTS_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.GPSR_SERVICE,
		path: PATHS.GPSR_SERVICE_PAGE,
		badge: null,
	},
	{
		name: NAVIGATE_ITEMS.EUDR_SERVICE,
		path: PATHS.EUDR_SERVICE_PAGE,
		badge: 'New',
	},
	{
		name: NAVIGATE_ITEMS.EU_DDP_SHIPMENTS,
		path: PATHS.EU_DDP_PAGE,
		badge: 'New',
	},
	{
		name: NAVIGATE_ITEMS.EPR_PPWR,
		path: PATHS.EPR_PPWR_PAGE,
		badge: 'New',
		activePaths: [
			PATHS.PPWR_MANUAL_REPORT_PAGE,
			PATHS.PPWR_PACKING_PROFILE_PAGE,
			PATHS.PPWR_COUNTRY_EXCLUSION_PAGE,
		],
	},
];

export const NAVIGATE_USER_MENU = [
	{
		type: 'MenuItem',
		name: 'Contract',
		path: PATHS.CONTRACT_PAGE,
		icon: React.createElement(HistoryEduIcon, { fontSize: 'small' }),
	},
	{
		type: 'divider',
		name: 'Divider',
		path: '',
		icon: null,
	},
	{
		type: 'MenuItem',
		name: 'General Settings',
		path: PATHS.GENERAL_SETTINGS_PAGE,
		icon: React.createElement(Settings, { fontSize: 'small' }),
	},
	{
		type: 'MenuItem',
		name: 'Supported Countries',
		path: PATHS.SUPPORTED_COUNTRIES_PAGE,
		icon: React.createElement(Public, { fontSize: 'small' }),
		new: true,
	},
	{
		type: 'MenuItem',
		name: 'User Management',
		path: PATHS.USER_MANAGEMENT_PAGE,
		icon: React.createElement(PeopleAlt, { fontSize: 'small' }),
		new: true,
	},
	{
		type: 'MenuItem',
		name: 'Security Settings',
		path: PATHS.SECURITY_SETTINGS_PAGE,
		icon: React.createElement(Security, { fontSize: 'small' }),
	},
	{
		type: 'MenuItem',
		name: 'Payment Methods',
		path: PATHS.PAYMENT_METHODS_PAGE,
		icon: React.createElement(CreditCard, { fontSize: 'small' }),
	},
	{
		type: 'divider',
		name: 'Divider',
		path: '',
		icon: null,
	},
	{
		type: 'MenuItem',
		name: 'Pricing',
		path: PRICING_PAGE,
		icon: React.createElement(PriceChange, { fontSize: 'small' }),
	},
	{
		type: 'MenuItem',
		name: 'Integrations',
		path: PATHS.INTEGRATIONS_PAGE,
		icon: React.createElement(IntegrationInstructions, { fontSize: 'small' }),
	},
	{
		type: 'MenuItem',
		name: 'Shopify Dev App',
		path: PATHS.SHOPIFY_DEV_APPS_PAGE,
		icon: React.createElement(Storefront, { fontSize: 'small' }),
		new: true,
	},
	{
		type: 'MenuItem',
		name: 'Uploaded Sales Reports',
		path: PATHS.UPLOADED_SALES_REPORTS_PAGE,
		icon: React.createElement(UploadFile, { fontSize: 'small' }),
	},
];
